<script setup lang="ts">
import { FhText } from '@fareharbor-com/beacon-vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import type { ItemListTableInstance } from './types';

interface ItemListLocationProps {
  row: ItemListTableInstance;
}

defineProps<ItemListLocationProps>();
</script>

<template>
  <BaseFlexbox class="px-1 py-2" direction="column">
    <FhText variant="body-md" weight="medium">{{ row.city }}</FhText>
    <FhText variant="body-sm">
      {{ row.region }}{{ row.region === '' ? '' : ',' }} {{ row.countryCode }}
    </FhText>
  </BaseFlexbox>
</template>
